import { Link } from "react-router-dom";
import type { ComicArticle } from "@/mocks/comics";

interface PopularRankingProps {
  comics: ComicArticle[];
}

export default function PopularRanking({ comics }: PopularRankingProps) {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-display text-foreground-950">
                人气排行
              </h2>
              <p className="text-sm text-foreground-500 mt-1">
                累计阅读量最高的热门漫画
              </p>
            </div>
          </div>

          <div className="space-y-0">
            {comics.slice(0, 10).map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="flex items-center gap-3 py-3 border-b border-background-200/70 last:border-b-0 hover:bg-background-50 transition-colors rounded-lg px-2 -mx-2 cursor-pointer"
                data-product-shop=""
              >
                <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                  idx < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}>
                  {idx + 1}
                </div>
                <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 免费韩漫在线阅读`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {comic.author} · {comic.category}
                  </p>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="flex items-center gap-1 text-xs text-accent-500">
                    <i className="ri-fire-line"></i>
                    <span className="font-medium">
                      {comic.views >= 1000000
                        ? `${(comic.views / 10000).toFixed(0)}万`
                        : `${(comic.views / 1000).toFixed(0)}k`}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs mr-0.5"></i>
                    {comic.rating}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="lg:w-[320px] flex-shrink-0">
          <div className="bg-background-100/70 rounded-xl p-5 sticky top-20">
            <h3 className="text-base font-display text-foreground-950 mb-4">
              推荐分类
            </h3>
            <div className="flex flex-wrap gap-2">
              {["恋爱", "奇幻", "动作", "剧情", "搞笑", "悬疑", "校园", "古风"].map((cat) => {
                const slugMap: Record<string, string> = {
                  恋爱: "lianai", 奇幻: "qihuan", 动作: "dongzuo", 剧情: "juqing",
                  搞笑: "gaoxiao", 悬疑: "xuanyi", 校园: "xiaoyuan", 古风: "gufeng",
                };
                return (
                  <Link
                    key={cat}
                    to={`/category/${slugMap[cat]}`}
                    className="px-3 py-1.5 rounded-full bg-background-50 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}